import { IconButton } from "@radix-ui/themes";
import { Pencil2Icon } from "@radix-ui/react-icons";
import { memo } from "react";

interface HoverDetailsButtonProps {
  onClick?: () => void;
}

const HoverDetailsButtonComponent = ({ onClick }: HoverDetailsButtonProps) => {
  if (!onClick) return null;

  return (
    <IconButton
      size="2"
      variant="ghost"
      color="gray"
      className="absolute top-1 right-1 w-5 h-5 border border-gray-300 shadow-sm opacity-0 group-hover:opacity-100 transition-opacity duration-150 cursor-pointer"
      onClick={() => onClick()}
    >
      <Pencil2Icon className="w-3.5 h-3.5" />
    </IconButton>
  );
};

export const HoverDetailsButton = memo(HoverDetailsButtonComponent);
